var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Delta",class:{
    'green' : _vm.x > 0,
    'grey'  : _vm.x == 0,
    'red'   : _vm.x < 0
  }},[(_vm.showNumber)?[(_vm.x > 0)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.x)+"\n  ")]:[(_vm.x > 0)?_c('i',{staticClass:"fas fa-angle-up"}):_vm._e(),(_vm.x == 0)?_c('strong',[_vm._v("-")]):_vm._e(),(_vm.x < 0)?_c('i',{staticClass:"fas fa-angle-down"}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }